import React from 'react';

import CustomerDetails from './customer-details';

const { UI, Order, Customer } = Mobi2Go;

Order.onReady(() => {
    const modal = UI.ExternalModal.create(
        'customer-details',
        <CustomerDetails
            closeModal={retain_overlay => {
                modal.close(retain_overlay);
            }}
            setModalIsClosable={is_closable => modal.setIsClosable(is_closable)}
        />,
        {
            'data-view': 'customer-details',
            className: 'm2g-customer-details',
        }
    );

    modal.mount();

    UI.bind('showCustomerDetails', () => {
        if (!Customer.isLoggedIn()) {
            return;
        }
        modal.open();
    });
});
